import React, { useRef } from 'react';
import { useApp } from '../context/AppContext';
import { SUPPORTED_GAMES } from '../data/catalog';
import Icon from './Icon';
import './TopGames.css';

export default function TopGames() {
  const { navigate } = useApp();
  const scrollerRef = useRef(null);

  const scrollBy = (dir) => {
    if (!scrollerRef.current) return;
    scrollerRef.current.scrollBy({ left: dir * 660, behavior: 'smooth' });
  };

  return (
    <section className="topgames">
      <div className="container">
        <div className="topgames__head">
          <div>
            <div className="eyebrow">MyCard 支援遊戲</div>
            <h2>300+ 款熱門遊戲</h2>
            <p className="muted topgames__lead">
              下列為部分台灣最受歡迎的遊戲，皆支援 MyCard 點數儲值
            </p>
          </div>
          <div className="topgames__nav">
            <button
              type="button"
              className="topgames__navbtn"
              onClick={() => scrollBy(-1)}
              aria-label="上一頁"
            >
              <Icon name="arrowLeft" size={14} />
            </button>
            <button
              type="button"
              className="topgames__navbtn"
              onClick={() => scrollBy(1)}
              aria-label="下一頁"
            >
              <Icon name="arrowRight" size={14} />
            </button>
          </div>
        </div>
        <div className="topgames__scroller" ref={scrollerRef}>
          {SUPPORTED_GAMES.map((g) => (
            <button
              key={g.id}
              type="button"
              className="topgames__card"
              style={{ '--gc-bg': g.bg }}
              onClick={() => navigate('category', { id: 'all' })}
              aria-label={`${g.name} 支援 MyCard`}
            >
              <span
                className="topgames__img"
                style={{ backgroundImage: `url(${g.image})` }}
              />
              <span className="topgames__overlay" />
              <span className="topgames__info">
                <span className="topgames__name">{g.name}</span>
                <span className="topgames__price">{g.publisher}</span>
              </span>
              <span className="topgames__tags">
                {g.tags.map((t) => (
                  <em key={t}>{t}</em>
                ))}
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
